export default __webpack_public_path__ + "static/media/icn-gear.7a03bb47.svg";